/** Team strengths. Keyed by slug; index is radar/table column order. */
export const order = ["serviceOrientation", "analysis", "innovation", "planningAndOrganizing", "initiativeAndResponsibility", "coordination", "coOperation", "qualityControl", "promoting"];

const dictionary = {
  "en": {
    "serviceOrientation": {
      "id": "serviceOrientation",
      "index": 0,
      "title": "Service orientation",
      "summary": "Understands the demands and requirements of (internal or external) clients; respects anxieties, doubts and arguments of clients when presenting results; considers the commercial, financial and political consequences of its activities and proposals.",
      "high": [
        "Aim to understands the demands and requirements of (internal or external) clients",
        "Respects anxieties, doubts and arguments of clients when presenting results",
        "Considers the commercial, financial and political consequences of its activities and proposals"
      ],
      "low": [
        "The opinions of some significant customers or stakeholders may not be heard",
        "Differing opinions and views are not taken seriously enough",
        "Different kind of customer types or behaviours are not considered",
        "Decisions result in unexpected problems in long-term implementation with customers or stakeholders"
      ]
    },
    "analysis": {
      "id": "analysis",
      "index": 1,
      "title": "Analysis",
      "summary": "Quickly develops an in-depth understanding of even complex issues and problems; constantly and critically reflects own approach; comes up with a sound and balanced judgment.",
      "high": [
        "Quickly develops an in-depth understanding of even complex issues and  problems",
        "Constantly and critically reflects own approach",
        "Comes up with a sound and balanced judgment"
      ],
      "low": [
        "Understanding of problems and issues tends to be too superficial or intuitive",
        "Approaches are not reflected or examined critically",
        "The conclusions are poorly justified; the core of things remains undiscovered",
        "Analyzes are imprecise or not done at all"
      ]
    },
    "innovation": {
      "id": "innovation",
      "index": 2,
      "title": "Innovation",
      "summary": "Challenges traditional approaches and assumptions; generates fresh and creative ideas and solutions; is open to change and innovation; acts flexibly.",
      "high": [
        "Challenges traditional approaches and assumptions",
        "Generates fresh and creative ideas and solutions",
        "Is open to change and innovation",
        "Acts flexibly"
      ],
      "low": [
        "Approaches, operating models, and assumptions are not challenged",
        "Ideas and solutions are not different neither stand out",
        "Changes and innovations, even necessary ones, are approached too cautiously",
        "The operation is rigid and does not react, let alone positively anticipate change"
      ]
    },
    "planningAndOrganizing": {
      "id": "planningAndOrganizing",
      "index": 3,
      "title": "Planning and organizing",
      "summary": "Translates goals and strategies into concrete project plans; makes efficient use of the available resources; considers short and long-term necessities and priorities; monitors own progress by using clear deadlines and milestones.",
      "high": [
        "Translates goals and strategies into concrete project plans",
        "Makes efficient use of the available resources",
        "Considers short and long-term necessities and priorities",
        "Monitors own progress by using clear deadlines and milestones"
      ],
      "low": [
        "Goals and strategy do not turn into plans; the team ends up in the wrong direction or place",
        "ROI for resource use is bad",
        "Long- and short-term priorities are not sufficiently balanced",
        "Progress is not tracked; there is no feedback on the activity; motivation decreases, difficult to assess the situation"
      ]
    },
    "initiativeAndResponsibility": {
      "id": "initiativeAndResponsibility",
      "index": 4,
      "title": "Implementation",
      "summary": "Acts on own initiative: drives things forward in an ambitious and committed manner; focuses own energy on reaching results; accepts responsibility for own activities and mistakes.",
      "high": [
        "Acts on own initiative",
        "Drives things forward in an ambitious and committed manner",
        "Focuses own energy on reaching results",
        "Accepts responsibility for own activities and mistakes"
      ],
      "low": [
        "things are not progressing, drive and commitment are missing",
        "focus is unclear, energy is used for secondaries",
        "expecting too many permissions and approvals from others for our own activities",
        "the ability to admit one's share of mistakes and failures is poor; no learning"
      ]
    },
    "coordination": {
      "id": "coordination",
      "index": 5,
      "title": "Coordination",
      "summary": "Makes sure each team member knows and shares the same goals; clearly defines individual objectives, tasks and responsibilities; makes optimum use of individual talents, knowledge and experience.",
      "high": [
        "Makes sure each team member knows and shares the same goals",
        "Clearly defines individual objectives, tasks and responsibilities",
        "Makes optimum use of individual talents, knowledge and experience"
      ],
      "low": [
        "Goals may be unclear or even non-existent",
        "Individual responsibilities are unclear or do not exist",
        "The team's strengths and potential may remain unutilized or not developed"
      ]
    },
    "coOperation": {
      "id": "coOperation",
      "index": 6,
      "title": "Cooperation",
      "summary": "Fosters a positive team spirit; shares information, ideas, knowledge and experience; involves all team members in planning and decision making; ensures all team members are supported and integrated even in difficult times.",
      "high": [
        "Fosters a positive team spirit",
        "Shares information, ideas, knowledge and experience",
        "Involves all team members in planning and decision making",
        "Ensures all team members are supported and integrated even in difficult times"
      ],
      "low": [
        "Team spirit can be low or becomes negative more easily",
        "Essential information does not pass to each other’s",
        "Team members are not sufficiently involved in planning and decision-making",
        "Unity is lower, the team does not feel that it is a team, but rather a group"
      ]
    },
    "qualityControl": {
      "id": "qualityControl",
      "index": 7,
      "title": "Quality control",
      "summary": "Sees tasks and projects through to completion; focuses own energy on reaching results; ensures it delivers high quality output.",
      "high": [
        "Sees tasks and projects through to completion",
        "Focuses own energy on reaching results",
        "Ensures it delivers high quality output"
      ],
      "low": [
        "Tasks and project remain do, not complete, in schedule or stay unfinished",
        "The customer value promise is not fulfilled as agreed",
        "Energy is used for the wrong things",
        "There is too much variation in quality or it is bad"
      ]
    },
    "promoting": {
      "id": "promoting",
      "index": 8,
      "title": "Promoting",
      "summary": "Successfully promotes own plans, initiatives and ideas; stands own ground in the face of opposition; builds a useful network of contacts and relationships and utilizes it to achieve objectives.",
      "high": [
        "Successfully promotes own plans, initiatives and ideas",
        "Stands own ground in the face of opposition",
        "Builds a useful network of contacts and relationships and utilizes it to achieve objectives"
      ],
      "low": [
        "Promotion of plans, initiatives and ideas is not successful",
        "The network of new useful contacts is not actively developed and utilized",
        "The attention of the potential target groups inside or outside organizations is not achieved",
        "The target groups are not convinced or influenced by the presented ideas and thoughts",
        "There is little or no challenging of each other’s views, ideas and assumptions"
      ]
    }
  },
  "de": {
    "serviceOrientation": {
      "id": "serviceOrientation",
      "index": 0,
      "title": "Serviceorientierung",
      "summary": "Versteht die Anforderungen und Erwartungen interner und externer Kundinnen und Kunden; nimmt Ängste, Zweifel und Einwände bei der Präsentation von Ergebnissen ernst; berücksichtigt die wirtschaftlichen, finanziellen und politischen Folgen des eigenen Handelns und der eigenen Vorschläge.",
      "high": [
        "Strebt an, die Anforderungen und Erwartungen interner und externer Kundinnen und Kunden zu verstehen",
        "Nimmt Ängste, Zweifel und Einwände bei der Präsentation von Ergebnissen ernst",
        "Berücksichtigt die wirtschaftlichen, finanziellen und politischen Folgen des eigenen Handelns und der eigenen Vorschläge"
      ],
      "low": [
        "Die Meinungen wichtiger Kundinnen, Kunden oder Stakeholder werden möglicherweise nicht gehört",
        "Abweichende Meinungen und Sichtweisen werden nicht ernst genug genommen",
        "Unterschiedliche Kundentypen und Verhaltensweisen werden nicht berücksichtigt",
        "Entscheidungen führen bei der langfristigen Umsetzung mit Kundinnen, Kunden oder Stakeholdern zu unerwarteten Problemen"
      ]
    },
    "analysis": {
      "id": "analysis",
      "index": 1,
      "title": "Analyse",
      "summary": "Entwickelt rasch ein fundiertes Verständnis auch komplexer Sachverhalte und Probleme; hinterfragt den eigenen Ansatz fortlaufend und kritisch; kommt zu einem soliden und ausgewogenen Urteil.",
      "high": [
        "Entwickelt rasch ein fundiertes Verständnis auch komplexer Sachverhalte und Probleme",
        "Hinterfragt den eigenen Ansatz fortlaufend und kritisch",
        "Kommt zu einem soliden und ausgewogenen Urteil"
      ],
      "low": [
        "Das Verständnis von Problemen und Sachverhalten bleibt zu oberflächlich oder rein intuitiv",
        "Vorgehensweisen werden nicht reflektiert oder kritisch geprüft",
        "Schlussfolgerungen sind schwach begründet; der Kern der Sache bleibt unerkannt",
        "Analysen sind ungenau oder unterbleiben ganz"
      ]
    },
    "innovation": {
      "id": "innovation",
      "index": 2,
      "title": "Innovationsfähigkeit",
      "summary": "Hinterfragt traditionelle Ansätze und Annahmen; entwickelt frische und kreative Ideen und Lösungen; ist offen für Wandel und Innovation; handelt flexibel.",
      "high": [
        "Hinterfragt traditionelle Ansätze und Annahmen",
        "Entwickelt frische und kreative Ideen und Lösungen",
        "Ist offen für Wandel und Innovation",
        "Handelt flexibel"
      ],
      "low": [
        "Ansätze, Betriebsmodelle und Annahmen werden nicht hinterfragt",
        "Ideen und Lösungen unterscheiden sich nicht und heben sich nicht ab",
        "Veränderungen und Innovationen, auch notwendige, werden zu zurückhaltend angegangen",
        "Das Vorgehen ist starr und reagiert nicht auf Veränderungen, geschweige denn, dass es sie vorausschauend aufgreift"
      ]
    },
    "planningAndOrganizing": {
      "id": "planningAndOrganizing",
      "index": 3,
      "title": "Planung und Organisation",
      "summary": "Übersetzt Ziele und Strategien in konkrete Projektpläne; setzt verfügbare Ressourcen effizient ein; berücksichtigt kurz- und langfristige Erfordernisse und Prioritäten; steuert den eigenen Fortschritt über klare Fristen und Meilensteine.",
      "high": [
        "Übersetzt Ziele und Strategien in konkrete Projektpläne",
        "Setzt verfügbare Ressourcen effizient ein",
        "Berücksichtigt kurz- und langfristige Erfordernisse und Prioritäten",
        "Steuert den eigenen Fortschritt über klare Fristen und Meilensteine"
      ],
      "low": [
        "Ziele und Strategie werden nicht in Pläne überführt; das Team steuert in die falsche Richtung oder landet am falschen Ort",
        "Die Rendite (ROI) des Ressourceneinsatzes ist schlecht",
        "Lang- und kurzfristige Prioritäten werden nicht ausreichend ausbalanciert",
        "Fortschritt wird nicht nachgehalten; es fehlt Feedback zur Aktivität; die Motivation sinkt, die Lage ist schwer einzuschätzen"
      ]
    },
    "initiativeAndResponsibility": {
      "id": "initiativeAndResponsibility",
      "index": 4,
      "title": "Umsetzung",
      "summary": "Handelt aus eigener Initiative: treibt Dinge ehrgeizig und engagiert voran; richtet die eigene Energie auf Ergebnisse; übernimmt Verantwortung für das eigene Handeln und für Fehler.",
      "high": [
        "Handelt aus eigener Initiative",
        "Treibt Dinge ehrgeizig und engagiert voran",
        "Richtet die eigene Energie auf Ergebnisse",
        "Übernimmt Verantwortung für das eigene Handeln und für Fehler"
      ],
      "low": [
        "Dinge kommen nicht voran; Antrieb und Engagement fehlen",
        "Der Fokus ist unklar; Energie fließt in Nebensächlichkeiten",
        "Für das eigene Handeln werden zu viele Freigaben und Genehmigungen anderer erwartet",
        "Die Bereitschaft, den eigenen Anteil an Fehlern und Misserfolgen einzugestehen, ist gering; es findet kein Lernen statt"
      ]
    },
    "coordination": {
      "id": "coordination",
      "index": 5,
      "title": "Koordination",
      "summary": "Stellt sicher, dass jedes Teammitglied dieselben Ziele kennt und teilt; definiert individuelle Ziele, Aufgaben und Verantwortlichkeiten klar; nutzt individuelle Talente, Wissen und Erfahrung optimal.",
      "high": [
        "Stellt sicher, dass jedes Teammitglied dieselben Ziele kennt und teilt",
        "Definiert individuelle Ziele, Aufgaben und Verantwortlichkeiten klar",
        "Nutzt individuelle Talente, Wissen und Erfahrung optimal"
      ],
      "low": [
        "Ziele können unklar sein oder ganz fehlen",
        "Individuelle Verantwortlichkeiten sind unklar oder existieren nicht",
        "Stärken und Potenzial des Teams bleiben ungenutzt oder unentwickelt"
      ]
    },
    "coOperation": {
      "id": "coOperation",
      "index": 6,
      "title": "Kooperation",
      "summary": "Fördert einen positiven Teamgeist; teilt Informationen, Ideen, Wissen und Erfahrung; bezieht alle Teammitglieder in Planung und Entscheidungsfindung ein; stellt sicher, dass alle Teammitglieder auch in schwierigen Zeiten unterstützt und eingebunden sind.",
      "high": [
        "Fördert einen positiven Teamgeist",
        "Teilt Informationen, Ideen, Wissen und Erfahrung",
        "Bezieht alle Teammitglieder in Planung und Entscheidungsfindung ein",
        "Stellt sicher, dass alle Teammitglieder auch in schwierigen Zeiten unterstützt und eingebunden sind"
      ],
      "low": [
        "Der Teamgeist kann schwach sein oder kippt leichter ins Negative",
        "Wesentliche Informationen gelangen nicht zu den anderen",
        "Teammitglieder werden unzureichend in Planung und Entscheidungsfindung einbezogen",
        "Der Zusammenhalt ist geringer; das Team erlebt sich nicht als Team, sondern eher als Gruppe"
      ]
    },
    "qualityControl": {
      "id": "qualityControl",
      "index": 7,
      "title": "Qualitätskontrolle",
      "summary": "Führt Aufgaben und Projekte bis zum Abschluss; richtet die eigene Energie auf Ergebnisse; stellt eine hohe Qualität der Ergebnisse sicher.",
      "high": [
        "Führt Aufgaben und Projekte bis zum Abschluss",
        "Richtet die eigene Energie auf Ergebnisse",
        "Stellt eine hohe Qualität der Ergebnisse sicher"
      ],
      "low": [
        "Aufgaben und Projekte bleiben liegen, werden nicht termingerecht abgeschlossen oder bleiben unvollständig",
        "Das Wertversprechen gegenüber Kundinnen und Kunden wird nicht wie vereinbart erfüllt",
        "Energie fließt in die falschen Dinge",
        "Die Qualität schwankt zu stark oder ist schlecht"
      ]
    },
    "promoting": {
      "id": "promoting",
      "index": 8,
      "title": "Überzeugen",
      "summary": "Wirbt erfolgreich für eigene Pläne, Initiativen und Ideen; bleibt bei Gegenwind standhaft; baut ein nützliches Netzwerk aus Kontakten und Beziehungen auf und nutzt es, um Ziele zu erreichen.",
      "high": [
        "Wirbt erfolgreich für eigene Pläne, Initiativen und Ideen",
        "Bleibt bei Gegenwind standhaft",
        "Baut ein nützliches Netzwerk aus Kontakten und Beziehungen auf und nutzt es, um Ziele zu erreichen"
      ],
      "low": [
        "Die Bewerbung von Plänen, Initiativen und Ideen ist nicht erfolgreich",
        "Das Netzwerk neuer nützlicher Kontakte wird nicht aktiv aufgebaut und genutzt",
        "Die Aufmerksamkeit potenzieller Zielgruppen innerhalb oder außerhalb von Organisationen wird nicht erreicht",
        "Die Zielgruppen werden von den vorgebrachten Ideen und Gedanken nicht überzeugt oder beeinflusst",
        "Sichtweisen, Ideen und Annahmen der anderen werden kaum oder gar nicht hinterfragt"
      ]
    }
  },
  "fi": {
    "serviceOrientation": {
      "id": "serviceOrientation",
      "index": 0,
      "title": "Palveluhenkisyys",
      "summary": "Ymmärtää (sisäisten tai ulkoisten) asiakkaiden vaatimukset ja tarpeet; kunnioittaa asiakkaiden huolia, epäilyksiä ja argumentteja tuloksia esittäessään; ottaa huomioon toimintansa ja ehdotustensa kaupalliset, taloudelliset ja poliittiset seuraukset.",
      "high": [
        "Pyrkii ymmärtämään (sisäisten tai ulkoisten) asiakkaiden vaatimukset ja tarpeet",
        "Kunnioittaa asiakkaiden huolia, epäilyksiä ja näkökantoja tuloksia esitellessään",
        "Harkitsee toimintansa ja ehdotustensa kaupallisia, taloudellisia ja poliittisia seurauksia"
      ],
      "low": [
        "Joidenkin merkittävien asiakkaiden tai sidosryhmien mielipiteitä ei ehkä kuulla",
        "Eriävät mielipiteet ja näkemykset eivät saa tarpeeksi huomiota",
        "Erilaisia asiakastyyppejä tai asiakkaiden toimintatapoja ei oteta huomioon",
        "Päätökset aiheuttavat odottamattomia ongelmia, kun niitä toteutetaan pitkällä aikavälillä asiakkaiden tai sidosryhmien kanssa"
      ]
    },
    "analysis": {
      "id": "analysis",
      "index": 1,
      "title": "Analyysi",
      "summary": "Muodostaa nopeasti syvällisen käsityksen monimutkaisistakin asioista ja ongelmista; arvioi jatkuvasti ja kriittisesti omaa lähestymistapaansa; päätyy perusteltuun ja tasapainoiseen arvioon.",
      "high": [
        "Muodostaa nopeasti syvällisen käsityksen monimutkaisistakin asioista ja ongelmista",
        "Pohdiskelee jatkuvasti ja kriittisesti omaa lähestymistapaansa",
        "Tekee järkevän ja tasapainoisen arvion"
      ],
      "low": [
        "Ongelmat ja asiat ymmärretään usein liian pintapuolisesti tai intuitiivisesti",
        "Lähestymistapoja ei pohdita tai tarkastella kriittisesti",
        "Johtopäätökset ovat huonosti perusteltuja; asioiden ydin jää löytämättä",
        "Analyysit ovat epätarkkoja tai niitä ei tehdä lainkaan"
      ]
    },
    "innovation": {
      "id": "innovation",
      "index": 2,
      "title": "Innovatiivisuus",
      "summary": "Kyseenalaistaa perinteiset lähestymistavat ja olettamukset; tuottaa tuoreita ja luovia ideoita ja ratkaisuja; on avoin muutokselle ja innovaatioille; toimii joustavasti.",
      "high": [
        "Kyseenalaistaa perinteiset lähestymistavat ja olettamukset",
        "Tuottaa tuoreita ja luovia ideoita ja ratkaisuja",
        "On avoin muutokselle ja innovaatioille",
        "Toimii joustavasti"
      ],
      "low": [
        "Lähestymistapoja, toimintamalleja ja oletuksia ei kyseenalaisteta",
        "Ideat ja ratkaisut eivät ole omaperäisiä eivätkä erotu edukseen",
        "Muutoksiin ja innovaatioihin, tarpeellisiinkin, suhtaudutaan liian varovaisesti",
        "Toiminta on jäykkää eikä reagoi muutokseen, saati ennakoi sitä myönteisesti"
      ]
    },
    "planningAndOrganizing": {
      "id": "planningAndOrganizing",
      "index": 3,
      "title": "Suunnittelu ja organisointi",
      "summary": "Muuttaa tavoitteet ja strategiat konkreettisiksi projektisuunnitelmiksi; käyttää saatavilla olevia resursseja tehokkaasti; ottaa huomioon lyhyen ja pitkän aikavälin tarpeet ja prioriteetit; seuraa omaa edistymistään selkeiden määräaikojen ja välitavoitteiden avulla.",
      "high": [
        "Muuttaa tavoitteet ja strategiat konkreettisiksi projektisuunnitelmiksi",
        "Käyttää saatavilla olevia resursseja tehokkaasti",
        "Ottaa huomioon lyhyen ja pitkän aikavälin tarpeet ja prioriteetit",
        "Seuraa omaa edistymistään käyttämällä selkeitä määräaikoja ja virstanpylväitä"
      ],
      "low": [
        "Tavoitteet ja strategia eivät muutu suunnitelmiksi; tiimi päätyy väärään suuntaan tai paikkaan",
        "Resurssien käytön tuotto on huono",
        "Pitkän ja lyhyen aikavälin prioriteetteja ei ole riittävästi tasapainotettu",
        "Edistymistä ei seurata; toiminnasta ei saada palautetta; motivaatio laskee, tilanteen arviointi on vaikeaa"
      ]
    },
    "initiativeAndResponsibility": {
      "id": "initiativeAndResponsibility",
      "index": 4,
      "title": "Toteutus",
      "summary": "Toimii oma-aloitteisesti: vie asioita eteenpäin kunnianhimoisesti ja sitoutuneesti; keskittää energiansa tulosten saavuttamiseen; ottaa vastuun omasta toiminnastaan ja virheistään.",
      "high": [
        "Toimii oma-aloitteisesti",
        "Vie asioita eteenpäin kunnianhimoisesti ja sitoutuneesti",
        "Keskittää oman energiansa tulosten saavuttamiseen",
        "Ottaa vastuun omista toimistaan ja virheistään"
      ],
      "low": [
        "Asiat eivät etene; tarmo ja sitoutuminen puuttuvat",
        "Fokus on epäselvä, energiaa kuluu toissijaisiin asioihin",
        "Omalle toiminnalle odotetaan muilta liikaa lupia ja hyväksyntöjä",
        "Kyky myöntää oma osuus virheistä ja epäonnistumisista on heikko; oppimista ei tapahdu"
      ]
    },
    "coordination": {
      "id": "coordination",
      "index": 5,
      "title": "Koordinointi",
      "summary": "Varmistaa, että jokainen tiimin jäsen tuntee yhteiset tavoitteet ja jakaa ne; määrittelee selkeästi yksilölliset tavoitteet, tehtävät ja vastuut; hyödyntää optimaalisesti jokaisen kykyjä, tietoja ja kokemusta.",
      "high": [
        "Varmistaa, että jokainen tiimin jäsen tuntee yhteiset tavoitteet ja sitoutuu niihin",
        "Määrittelee selkeästi henkilökohtaiset tavoitteet, tehtävät ja vastuut",
        "Hyödyntää yksilöiden kykyjä, tietoja ja kokemusta parhaalla mahdollisella tavalla"
      ],
      "low": [
        "Tavoitteet voivat olla epäselvät tai jopa olemattomat",
        "Henkilökohtaiset vastuut ovat epäselviä tai niitä ei ole määritelty",
        "Tiimin vahvuudet ja potentiaali saattavat jäädä hyödyntämättä tai kehittymättä"
      ]
    },
    "coOperation": {
      "id": "coOperation",
      "index": 6,
      "title": "Yhteistyö",
      "summary": "Edistää myönteistä tiimihenkeä; jakaa tietoa, ideoita, tietämystä ja kokemusta; ottaa kaikki tiimin jäsenet mukaan suunnitteluun ja päätöksentekoon; varmistaa, että kaikki tiimin jäsenet saavat tukea ja pysyvät mukana myös vaikeina aikoina.",
      "high": [
        "Edistää positiivista tiimihenkeä",
        "Jakaa tietoa, ideoita, osaamista ja kokemusta",
        "Ottaa kaikki tiimin jäsenet mukaan suunnitteluun ja päätöksentekoon",
        "Varmistaa, että kaikki tiimin jäsenet saavat tukea ja pysyvät mukana myös vaikeina aikoina"
      ],
      "low": [
        "Tiimihenki voi olla heikko tai muuttua helpommin kielteiseksi",
        "Oleellinen tieto ei kulje tiimin jäsenten välillä",
        "Tiimin jäseniä ei oteta riittävästi mukaan suunnitteluun ja päätöksentekoon",
        "Yhtenäisyys on heikompaa; tiimi ei koe olevansa tiimi vaan pikemminkin ryhmä"
      ]
    },
    "qualityControl": {
      "id": "qualityControl",
      "index": 7,
      "title": "Laadunvalvonta",
      "summary": "Vie tehtävät ja projektit loppuun asti; suuntaa energiansa tulosten saavuttamiseen; varmistaa, että työn tulos on laadukasta.",
      "high": [
        "Vie tehtävät ja projektit päätökseen",
        "Keskittää oman energiansa tulosten saavuttamiseen",
        "Varmistaa, että sen työn tulokset ovat korkealaatuisia"
      ],
      "low": [
        "Tehtävät ja projektit jäävät tekemättä, eivät valmistu aikataulussa tai jäävät keskeneräisiksi",
        "Asiakkaalle annettu arvolupaus ei toteudu sovitusti",
        "Energiaa käytetään vääriin asioihin",
        "Laadussa on liikaa vaihtelua tai se on huono"
      ]
    },
    "promoting": {
      "id": "promoting",
      "index": 8,
      "title": "Edistäminen",
      "summary": "Edistää menestyksekkäästi omia suunnitelmiaan, aloitteitaan ja ideoitaan; pitää pintansa vastustuksen edessä; rakentaa hyödyllisen kontakti- ja suhdeverkoston ja hyödyntää sitä tavoitteiden saavuttamisessa.",
      "high": [
        "Edistää menestyksekkäästi omia suunnitelmiaan, aloitteitaan ja ideoitaan",
        "Pysyy omilla linjoillaan vastustuksen edessä",
        "Rakentaa hyödyllisen kontaktien ja suhteiden verkoston ja hyödyntää sitä tavoitteiden saavuttamiseksi"
      ],
      "low": [
        "Suunnitelmien, aloitteiden ja ideoiden edistäminen ei onnistu",
        "Uusien hyödyllisten kontaktien verkostoa ei kehitetä eikä hyödynnetä aktiivisesti",
        "Mahdollisten kohderyhmien huomiota ei saada organisaation sisällä tai ulkopuolella",
        "Kohderyhmät eivät ole vakuuttuneita esitellyistä ideoista ja ajatuksista eivätkä vaikutu niistä",
        "Toisten näkemyksiä, ideoita ja oletuksia kyseenalaistetaan vähän tai ei lainkaan"
      ]
    }
  }
};

export default dictionary;
